module.exports = __webpack_public_path__ + "static/media/audio-green.92205fce.svg";